import { memo, useCallback } from 'react';

import { Webchat as WebchatWidget } from '@eduzz-automacoes/webchat-widget';
import { useAuthUser } from 'hooks/useAuthUser';
import userService from 'services/user';
import { type WebchatSession } from 'services/user/types';
import { WEBCHAT_CLIENT_ID, WEBCHAT_PROXY_URL } from 'settings';

const BLACK_BELTS = new Set(['Black', 'Golden', 'Sensei']);

function SupportChat() {
  const { data: user } = useAuthUser();

  const isProducer = user?.is_producer;

  const beltName = (user?.belt || 'White').split(' ')[0];

  const definePresetSlug = () => {
    if (user?.is_clube_black) return 'unity';
    return BLACK_BELTS.has(beltName) ? 'black' : 'default-eduzz';
  };

  const getSession = useCallback(async (): Promise<WebchatSession> => {
    const response = await userService.generateWebchatSession();
    const session = response?.data?.[0];
    if (!session?.userToken) throw new Error('Webchat session not created or empty');
    return session;
  }, []);

  if (!isProducer || !user?.cli_cod) return null;

  const authenticatedId = user?.acpo_original_user_cli_cod ?? user?.cli_cod;
  const controlledId = user?.cli_cod;

  return (
    <WebchatWidget
      clientId={WEBCHAT_CLIENT_ID}
      webchatProxyUrl={WEBCHAT_PROXY_URL}
      getSession={getSession}
      sessionKey={`${authenticatedId}:${controlledId}`}
      presetSlug={definePresetSlug()}
      storageKey={`blinket-webchat-${authenticatedId}:${controlledId}`}
      defaultUserData={{
        source: 'blinket-app'
      }}
    />
  );
}

export default memo(SupportChat);
